import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { EventoProdutoImport } from "../sigeve/evento/models/evento";
import { Estoque, Etapa, EtapaContagemAgregado, EtapaContagemUsuario, EtapaEstrutura, Inventario, InventarioProdutoImport } from "./models/inventario";

@Injectable({
  providedIn: 'root'
})

export class InventarioService {

  private environmentUrl: string = '';

  constructor(private httpClient: HttpClient) {
    this.environmentUrl = environment.ApiCore + '/inventario';
  }

  getInventarios() {
    return this.httpClient.get<Inventario[]>(this.environmentUrl);
  }

  delInventario(idEntidade: number) {
    return this.httpClient.delete(this.environmentUrl +"/" + idEntidade);
}

addInventario(entidade: Inventario) {
    return this.httpClient.post(this.environmentUrl , entidade);
}

updInventario(entidade: Inventario) {
    return this.httpClient.put(this.environmentUrl, entidade);
}

getEstoques() {
    return this.httpClient.get<Estoque[]>(this.environmentUrl+"/estoques");
  }

  getEtapa(idEtapa) {
    return this.httpClient.get<Etapa>(this.environmentUrl+"/etapa/"+idEtapa);
  }


  getEtapas(idInventario) {
    return this.httpClient.get<Etapa[]>(this.environmentUrl+"/"+idInventario+"/etapa");
  }

  getEtapaEstrutura(idEtapa) {
    return this.httpClient.get<EtapaEstrutura[]>(this.environmentUrl+"/etapa/"+idEtapa+"/estrutura");
  }

  delEtapa(idEntidade: number) {
    return this.httpClient.delete(this.environmentUrl +"/etapa/" + idEntidade);
}

finalizarEtapa(idEtapa) {
  return this.httpClient.put(this.environmentUrl+"/etapa/"+idEtapa+"/finalizar",{});
}

addEtapa(entidade: Etapa) {
    return this.httpClient.post(this.environmentUrl+"/etapa/" , entidade);
}

updEtapa(entidade: Etapa) {
    return this.httpClient.put(this.environmentUrl+"/etapa/", entidade);
}

realizarCarga(idEtapa) {
  return this.httpClient.put(this.environmentUrl+"/etapa/"+idEtapa+"/carga",{});
}

getEtapaContagem(idEtapa) {
  return this.httpClient.get<EtapaContagemAgregado[]>(this.environmentUrl+"/etapa/"+idEtapa+"/contagemAgregado");
}

getEtapaContagemUsuario(idEtapa) {
  return this.httpClient.get<EtapaContagemUsuario[]>(this.environmentUrl+"/etapa/"+idEtapa+"/contagemUsuario");
}

checkImportarContagens(idEtapa: number, listaProduto: InventarioProdutoImport[]): Observable<InventarioProdutoImport[]> {
  return this.httpClient.post<InventarioProdutoImport[]>(this.environmentUrl+"/etapa/"+idEtapa+"/importar",listaProduto);
}

}